module.exports = __webpack_public_path__ + "static/media/curriculum_s5.46bd5c0c.png";